import "@fontsource-variable/eb-garamond/wght.css";
import "@fontsource-variable/archivo/wght.css";
import "@fontsource-variable/source-sans-3/wght.css";
import "./src/styles/site.css";

import { initializeAnalytics } from "./src/lib/analytics";

import { shouldScrollToTop } from "./src/lib/route-scroll";

let historyNavigation = false;
let scrollFrame;
export const onClientEntry = () => {
  initializeAnalytics(
    window,
    process.env.NODE_ENV === "production" &&
      /^GTM-[A-Z0-9]+$/.test(process.env.GATSBY_GTM_ID || ""),
  );
  window.addEventListener("popstate", () => {
    historyNavigation = true;
  });
};

export const shouldUpdateScroll = ({ prevRouterProps, routerProps }) => {
  const scrollToTop = shouldScrollToTop({
    previous: prevRouterProps?.location,
    location: routerProps.location,
    historyNavigation,
  });
  historyNavigation = false;
  window.cancelAnimationFrame(scrollFrame);
  if (!scrollToTop) return true;
  // Let the mobile drawer release its body scroll lock before scrolling.
  scrollFrame = window.requestAnimationFrame(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
        ? "instant"
        : "smooth",
    });
  });
  return false;
};

export const onRouteUpdate = () => {
  window.irseAnalytics?.page();
};
